import { StateMachine } from 'tower/util';
import BattleScene from 'tower/scenes/battle';
import Enemy, { EnemyState } from 'tower/scenes/battle/enemy';
import { HitOptions } from 'tower/types';

interface BushOptions {
  burned?: boolean;
}

export default class Bush extends Enemy {
  burned = false;

  constructor(
    scene: BattleScene,
    x: number,
    y: number,
    public bushOptions?: BushOptions,
  ) {
    super(scene, x, y, 'enemies', 103, 'statue', {
      hideSpawn: true,
      turnable: false,
      solid: true,
    });
    this.body.setSize(16, 16);

    if (this.bushOptions?.burned) {
      this.stateMachine.transition('burned');
    }
  }

  async hit(options: HitOptions) {
    super.hit(options);
    if (options.weaponType === 'flame') {
      this.burned = true;
    }
  }

  makeStateMachine(scene: BattleScene) {
    return new StateMachine('idle', {
      idle: new BushIdleState(scene, this),
      burned: new BushBurnedState(scene, this),
    });
  }
}

class BushState extends EnemyState {
  declare enemy: Bush;
}

class BushIdleState extends BushState {
  handleEntered() {
    const { scene, enemy } = this;

    const handleFlameDestroyed = () => {
      if (enemy.burned) {
        scene.events.off('destroyflame', handleFlameDestroyed);
        return this.transition('burned');
      }
    };
    scene.events.on('destroyflame', handleFlameDestroyed);
    enemy.on('destroy', () => scene.events.off('destroyflame', handleFlameDestroyed));
  }
}

class BushBurnedState extends BushState {
  handleEntered() {
    this.enemy.setFrame(111);
    this.scene.events.emit('burnbush');
  }
}
